import React from 'react';
import PageHero from '../components/layout/PageHero';
import { ToolGuideCta } from '../components/layout/GuideLayout';
import EvMotorSizingCalculator from '../components/tools/EvMotorSizingCalculator';

const EvMotorSizingPage = () => {
  return (
    <div className="min-h-screen" data-testid="ev-motor-sizing-page">
      <PageHero
        eyebrow="Engineering Utilities"
        title="Electric Motor Sizing Calculator"
        description="Estimate continuous and peak motor power, torque, base and max RPM, and DC and phase current from vehicle mass, aerodynamics, traction limit, acceleration, top-speed, and grade targets."
        backTo="/tools"
        backLabel="Back to Tools"
        testId="ev-motor-sizing-hero"
      />
      <section className="py-12 md:py-16">
        <div className="max-w-screen-2xl mx-auto px-4 md:px-8">
          <EvMotorSizingCalculator />
          <ToolGuideCta guidePath="/tools/ev-motor-sizing/guide" toolName="Electric Motor Sizing Calculator" />
        </div>
      </section>
    </div>
  );
};

export default EvMotorSizingPage;
